import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderDraft,
  BackendMutationDeleteBlogPostBuilderDraftArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteBlogPostBuilderDraft($projectId: ID!, $draftId: ID!) {
    deleteBlogPostBuilderDraft(projectId: $projectId, draftId: $draftId) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBlogPostBuilderDraftArgs;
type Result = Pick<BackendBlogPostBuilderDraft, 'id'>;

export const deleteBlogPostBuilderDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
